import actions from './actions-user-group.js'
import mutations from './mutations-user-group.js'
import getters from './getters-user-group.js'
import state from './state-user-group.js'

export default {
    namespaced: true,
    actions,
    mutations,
    getters,
    state
}